window.Auth = {
	hideMsg: function ($form) {
		$form.find('.msg').hide();
	},
	showError: function ($form, msg) {
		$form.find('.msg.error').html(msg).show();
	},
	showSuccess: function ($form, msg) {
		$form.find('.msg.success').html(msg).show();
	},

	hideModalAuth: function () {
		let $modal = $("#modal-auth-user");
		$modal.modal('hide');
	},
	showModalEmail: function () {
		let $modal = $("#modal-submit-email");
		$modal.modal('show');
		Auth.hideMsg($modal.find('form'));
	},

	post: function ($form, callback) {
		var route = $form.attr('action');

		$.ajax({
			url: route,
			type: "POST",
			data: $form.serialize(),
			success: function (data) {
				callback(data);
			},
			error: function (xhr) {
				callback(JSON.parse(xhr.responseText));
			},
		});
	}
};

$(document).ready(function () {
	$("#form-reg").submit(function () {
		var $form = $(this);

		Auth.hideMsg($form);

		Auth.post($form, function (data) {
			$form.trigger('reload-btn');

			if (data.errors) {
				let msg = data.errors[Object.keys(data.errors)[0]];
				Auth.showError($form, msg);
			} else if (data.error) {
				Auth.showError($form, data.msg);
			} else if (data.redirect_to) {
				location.href = data.redirect_to;
			}
		});

		return false;
	});

	$("#form-login").submit(function () {
		var $form = $(this);

		Auth.hideMsg($form);

		Auth.post($form, function (data) {
			$form.trigger('reload-btn');

			if (data.errors) {
				let msg = data.errors[Object.keys(data.errors)[0]];
				Auth.showError($form, msg);
			} else if (data.error) {
				Auth.showError($form, data.msg);
			} else if (data.redirect_to) {
				location.href = data.redirect_to;
			}
		});

		return false;
	});

	$("#form-forgot").submit(function () {
		let route = $(this).attr('action');
		let params = $(this).serializeArray();
		let $form = $(this);

		Auth.hideMsg($form);

		$.post(route, params, function (data) {
			$form.trigger('reload-btn');

			if (data.error) {
				Auth.showError($form, data.msg);
			} else {
				Auth.showSuccess($form, data.msg);
			}
		});

		return false;
	});

	$("#form-email").submit(function () {
		let route = $(this).attr('action');
		let params = $(this).serializeArray();
		let $form = $(this);

		Auth.hideMsg($form);

		$.post(route, params, function (data) {
			$form.trigger('reload-btn');

			if (data.error) {
				Auth.showError($form, data.msg);
			} else {
				location.href = data.redirect_to;
			}
		});

		return false;
	});

	$('[data-toggle=forgot-tab]').click(function () {
		let $forgot = $('.forgot-tab'),
			$auth = $('.auth-tabs');

		$forgot.slideDown('slow');
		$auth.slideUp('slow');

		return false;
	});

	$('[data-toggle=auth-tabs]').click(function () {
		let $forgot = $('.forgot-tab'),
			$auth = $('.auth-tabs');

		$auth.slideDown('slow');
		$forgot.slideUp('slow');

		return false;
	});
});
